import { z } from 'zod';

/**
 * `?section=` contract of the project settings page. Lives apart from the page
 * so the route's eager `validateSearch` doesn't drag the whole settings page
 * (milestones, tags, AI agent form…) into the initial bundle.
 */
export const PROJECT_SETTINGS_SECTIONS = [
  'general',
  'members',
  'workflow',
  'milestones',
  'tags',
  'integrations',
  'billing',
  'ai',
  'danger',
] as const;
export type ProjectSettingsSection = (typeof PROJECT_SETTINGS_SECTIONS)[number];

export const projectSettingsSearchSchema = z.object({
  section: z.enum(PROJECT_SETTINGS_SECTIONS).optional(),
});
